import styled from 'styled-components';
import {SalesCompare} from '@/map/@types';
import {AgeGenderRadarChart as RadarChart} from '@/map/components/Chart';
import {ChartTitle} from '../../StyledComponents';
import {EMPTY_ITEM_TYPES} from '../constants';
import {EmptyItem} from '../EmptyItem';

export interface IProps {
  type: string;
  data: SalesCompare['ageGender'];
  compareItemName: string;
  compareItemIndex: number;
  tabIndex?: number;
}

export const AgeGenderRadarChart = ({type, data, compareItemName}: IProps) => {
  if (!data) {
    return null;
  }

  const emptyItem =
    !data.maleAgeGender?.length || !data.femaleAgeGender?.length;

  return (
    <Root key={type}>
      <ChartTitle>{compareItemName}</ChartTitle>
      {!emptyItem ? (
        <RadarChart data={data} />
      ) : (
        <EmptyItem type={EMPTY_ITEM_TYPES.Sales} />
      )}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
